var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 22.75L12.2115 21.601L8.48533 17.875H18.375C18.806 17.875 19.2193 17.7038 19.524 17.399C19.8288 17.0943 20 16.681 20 16.25V3.25H18.375V16.25H8.48533L12.2115 12.524L11.0625 11.375L5.375 17.0625L11.0625 22.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIcon);
export default __webpack_public_path__ + "static/media/enter-icon.7302f1fa32702caf5473bb312fb9c2b1.svg";
export { ForwardRef as ReactComponent };